type AsyncOperation<T> = () => T | Promise<T>;
type AsyncRollback = () => void | Promise<void>;
type CompensationAwareError = {
  compensationError?: unknown;
};

export const withCompensation = async <T>(
  operation: AsyncOperation<T>,
  rollback: AsyncRollback
): Promise<T> => {
  try {
    return await operation();
  } catch (error) {
    try {
      await rollback();
    } catch (compensationError) {
      if (error && typeof error === 'object') {
        (error as CompensationAwareError).compensationError = compensationError;
      }
    }
    throw error;
  }
};
